import { useEffect, useState } from "react";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";
import axios from "axios";
import { LISTING_TYPE } from "../platformUtils";



function useOwnedNFTs() {
  const [ownedNFTs, setOwnedNFTs] = useState<{[key: string]: any}[]>([]);
  const { REACT_APP_ALCHEMY_API_KEY } = process.env;
  const { walletAddress } = useAcreDapp();
  const [fetchSuccess, setFetchSuccess] = useState(true);
  // TODO: remove property specific properties
  // TODO: actually write the function and use a hook from Moralis

  const apiKey = `${REACT_APP_ALCHEMY_API_KEY}`;
  const baseURL = `https://eth-goerli.g.alchemy.com/v2/${apiKey}/getNFTs`;
  const ownerAddr = walletAddress;
  const baseURL2 = `https://deep-index.moralis.io/api/v2/${ownerAddr}/nft`;
  const options = {
    method: "GET",
    url: baseURL2,
    params: { chain: "goerli", format: "decimal" },
    headers: {accept: 'application/json', 'X-API-Key': 'slK8nctxdY5M4UCZHXc4ZWh394w1WqlhOHgRki2rQM5hjrR3y9pgV1cUamoLQm4w'}
  }

  const fetchURL = `${baseURL}?owner=${ownerAddr}`;

  useEffect(() => {
     function fetchNFTs() {
      axios
        .get(fetchURL)
        .then((response) => { //NOTE - Getting the NFTS is 50 50 somtimes you need to use .data.data and sometimes you dont
        //console.log(response.data);
        setOwnedNFTs(response?.data?.ownedNfts);
        })
        .catch((error) => console.log("error", error));
      setFetchSuccess(true);
    }
    if(ownerAddr){fetchNFTs();}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress]);

  return { ownedNFTs, fetchSuccess };
}

export default useOwnedNFTs;
